import 'suggestions-jquery/src/main';
import 'suggestions-jquery/dist/css/suggestions.css';
